var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-screen"},[_c('Animation',{ref:"loading-animation",attrs:{"animation-layers":['loader']}}),_c('div',{staticClass:"loader-bar",style:('--percentage: '+_vm.percentage+';')})],1)}
var staticRenderFns = []

export { render, staticRenderFns }